/**
 * Display an Alias chip.
 */

// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {IconEmailAt} from '@wandb/weave/components/Icon';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

const StyledAlias = styled.div`
  height: 24px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  background-color: rgba(179, 105, 79, 0.1);
  color: rgb(179, 105, 79);
  padding: 3px 8px;
  font-size: 14px;
  line-height: 18px;
  margin-right: 3px;
`;
StyledAlias.displayName = 'S.StyledAlias';

const IconAlias = styled(IconEmailAt)`
  width: 14px;
  height: 14px;
  margin-right: 4px;
`;
IconAlias.displayName = 'S.IconAlias';

export type AliasInfo = {
  alias: string;
};

type AliasProps = {
  alias: AliasInfo;
};

export const Alias = ({alias}: AliasProps) => {
  return (
    <StyledAlias>
      <IconAlias /> {alias.alias}
    </StyledAlias>
  );
};
